import { z } from 'zod'

export const step2Schema = z.object({
  name: z.string().min(1, 'File name cannot be blank'),
})
